const MAX_KEYWORDS = 5;

export function createShutterstockQuery(keywords) {
  if (!keywords?.length) {
    return "";
  }

  return keywords
    .map((keyword, index) => index < MAX_KEYWORDS && keyword)
    .filter((keyword) => keyword)
    .join(" OR ");
}
